import { defaultSnippetGrouping, type SnippetGrouping, type SnippetsQueryParams } from '../../../../../shared/snippets';
import { useQuery as useQueryParams } from '../../../../contexts/RouterContext';

/**
 * Custom hook to manage snippet grouping state.
 */
export default function useSnippetGrouping() {
  const [queryParams, setQueryParams] = useQueryParams<SnippetsQueryParams>();

  const snippetGrouping = queryParams.grouping ?? defaultSnippetGrouping;
  const setSnippetGrouping = (grouping: SnippetGrouping) => {
    setQueryParams({ ...queryParams, grouping });
  };

  return { snippetGrouping, setSnippetGrouping };
}
